import { getRequest } from '../services/requestHandler';
import { PlayerSupportLookup } from '../models';

export const getPlayerSupportLookups = async () => {
  const url = `player/GetPlayerSupportLookups?activeOnly=true&useCache=true`;
  const response = await getRequest<PlayerSupportLookup>('GetPlayerSupportLookups', url);
  return response;
};
